jQuery(document).ready(function($){

    $('.y_frm_slider').owlCarousel({
    loop:true,
    margin:20,
    responsiveClass:true,
    nav:true,
    responsive:{
        0:{
            items:1.5
        },
        767:{
            items:3
        },
        1024:{
            items:4
        }
    }
    });

    $('.y_rvwsld_slider').owlCarousel({
    loop:true,
    margin:20,
    responsiveClass:true,
    nav:true,
    responsive:{
        0:{
            items:1.3,
            center:true
        },
        767:{
            items:3,
            center:false
        },
        1024:{
            items:4,
            center:false
        }
    }
    });

    $('.y_faq_li h3').click(function() {
        $(this).next().slideToggle();
        $(this).parent().toggleClass('open');
    });

    $(window).scroll(function(){
  var sticky = $('#header-group'),
      scroll = $(window).scrollTop();

  if (scroll >= 46) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});

$('.y_gud_slider').owlCarousel({
    responsiveClass:true,
    nav:true,
    responsive:{
        0:{
            items:1.3,
            margin:20,
            loop:true
        },
        767:{
            items:3,
            margin:20,
            loop:false
        },
        1024:{
            items:3,
            margin:36,
            loop:false
        }
    }
    });

     $('.y_pdpfaq_li:nth-child(1)').addClass('open');
     $('.y_pdpfaq_li:nth-child(1) .y_p').show();
     $('.y_pdpfaq_li:nth-child(2)').addClass('open');
     $('.y_pdpfaq_li:nth-child(2) .y_p').show();

     $('.y_pdpfaq_li h3').click(function() {
        $(this).next().slideToggle();
        $(this).parent().toggleClass('open');
    });

    $('.y_vdrvw_slider').owlCarousel({
    responsiveClass:true,
    nav:true,
    loop:true,
    responsive:{
        0:{
            items:1.3,
            margin:22,
            center:true
        },
        767:{
            items:3,
            margin:22,
            center:false
        },
        1024:{
            items:4,
            margin:22,
            center:false
        }
    }
    });
 
    $(".y_vdrvw_tabbutton").click(function(event) {
        event.preventDefault();
        $(".y_vdrvw_tabbutton").removeClass("active");
        $(this).addClass("active");
        $(".y_vdrvw_container > div").hide();
        var activeTab = $(this).attr("href");
        $(activeTab).show();
    });

    $(".y_playpause").on("click", function() {
        $(".y_playpause").removeClass("hide");
          $(this).addClass("hide");
          $(".y_rvwsld .y_rvwsld_dv .item video").trigger("pause");
          $(this).parent().find("video").get(0).play();
    });

    $(".y_rvwsld .y_rvwsld_dv .item video").on("click", function() {
        $(this).trigger("pause");
        $(".y_playpause").removeClass("hide")
    });

    $(".y_vdrvw_playpause").on("click", function() {
        $(".y_vdrvw_playpause").removeClass("hide");
          $(this).addClass("hide");
          $(".y_vdrvw .y_vdrvw_container .y_vdrvw_video .y_vdrvw_slider .item video").trigger("pause");
          $(this).parent().find("video").get(0).play();
    });

    $(".y_vdrvw .y_vdrvw_container .y_vdrvw_video .y_vdrvw_slider .item video").on("click", function() {
        $(this).trigger("pause");
        $(".y_vdrvw_playpause").removeClass("hide")
    });

    $('.y_jrn_slider').owlCarousel({
    responsiveClass:true,
    loop:false,
    nav:true,
    responsive:{
        0:{
            items:1,
            margin:0
        },
        767:{
            items:3,
            margin:20
        },
        1024:{
            items:4,
            margin:74
        }
    }
    });

    $(".y_cntfaq_tab a").click(function(event) {
        event.preventDefault();
        $(".y_cntfaq_tab a").removeClass("active");
        $(this).addClass("active");
        $(".y_cntfaq_ul .y_cntfaq_li").hide();
        var targetDivId = $(this).data('hr');
        $('.' + targetDivId).toggle();
    });

    $(".y_cntfaq_tab a:first-child").click();

    $('.y_cntfaq_li h3').click(function() {
        $(this).next().slideToggle();
        $(this).parent().toggleClass('open');
    });

});